import PropTypes from 'prop-types';
import TicketsMultiFiltro from './TicketsMultiFiltro';

// Filtro multi-selección por estado para la cola de tickets. La mecánica del
// popover vive en TicketsMultiFiltro; aquí solo se adapta el catálogo de
// estados ({ id, descripcion }) al formato de opciones ({ id, label }).
const TicketsEstadoFilter = ({ estados, seleccionados, onChange }) => (
  <TicketsMultiFiltro
    etiqueta="Estado"
    ariaLabel="Filtrar por estado"
    opciones={estados.map((e) => ({ id: e.id, label: e.descripcion }))}
    seleccionados={seleccionados}
    onChange={onChange}
  />
);

TicketsEstadoFilter.propTypes = {
  estados: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      descripcion: PropTypes.string,
    }),
  ),
  seleccionados: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};

TicketsEstadoFilter.defaultProps = {
  estados: [],
  seleccionados: [],
};

export default TicketsEstadoFilter;
